// extracted by mini-css-extract-plugin
module.exports = {"barra":"BarraAreaAluno_barra__9FtZo","nome":"BarraAreaAluno_nome__12f5M","botaoSair":"BarraAreaAluno_botaoSair__2Prl6","textoSair":"BarraAreaAluno_textoSair__1WibI"};